export const createAction = (type, payload) => ({type, payload}); 
//only for return suitable variables, without must write type: (...), payload: (...) 
//when calling 